export function kendoLoader() {
	return $('#loader-overlay > div').kendoLoader({
		size: 'large',
		type: 'infinite-spinner',
	}).data("kendoLoader");
}